import React from 'react';
import ProtectedRoutes from './auth/ProtectedRoutes';
import Login from './components/common/Login';
import Logout from './components/common/Logout';
import Home from './components/common/Home';
import Admin from './components/common/Admin';
import PreloadingLogs from './components/preloading/PreloadingLogs';
import PreloadingForm from './components/preloading/preloadingForm';
import PreloadingList from './components/preloading/PreloadingList';
import Approval from './components/preloading/PreloadingApproval';
import CostSheetEntList from './components/costsheetEnt/CostSheetEntList';
import CostSheetEntLogs from './components/costsheetEnt/CostSheetEntLogs';
import CostSheetEntForm from './components/costsheetEnt/CostSheetEntForm';
import CostSheetEntAppv from './components/costsheetEnt/CostSheetEntApproval';
import CrmDetails from './components/common/CrmDetails';
import SalepersonMaster from './components/common/SalepersonMaster';
import MaintenancePage from './components/common/MaintenancePage';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { encryptRoute, decryptRoute } from './utils/decryptorUtils';

const App = () => {

  const isMaintenanceMode = false; 

  return (
    <>
      <Router>
        <Routes>
          
          {/* Admin */}
          <Route path="/Admin" element={<ProtectedRoutes Component={Admin} />} />
          {/* <Route path="/SuperAdminLogin" element={<Login />} /> */}

          {/* Common */}
          <Route path="/" element={isMaintenanceMode ? <MaintenancePage /> : <Login />} />
          <Route path="/Logout" element={<Logout />} />
          <Route path="/Home" element={<ProtectedRoutes Component={Home} />} />
          <Route path="/CrmDetails" element={<ProtectedRoutes Component={CrmDetails} />} />
          <Route path="/SalepersonMaster" element={<ProtectedRoutes Component={SalepersonMaster} />} />

          {/* Preloading - Phase 1 */}
          <Route path="/PreloadingList" element={<ProtectedRoutes Component={PreloadingList} />} />
          <Route path="/PreloadingLogs" element={<ProtectedRoutes Component={PreloadingLogs} />} />
          <Route path="/PreloadingForm/:series" element={<ProtectedRoutes Component={PreloadingForm} />} />
          <Route path='/PreloadingApprovals/:approvalRole/:encParam' element={<Approval />} />

          {/* CostSheet Enterprise - Phase 2 */}
          <Route path="/CostSheetEntList" element={<ProtectedRoutes Component={CostSheetEntList} />} />
          <Route path="/CostSheetEntLogs" element={<ProtectedRoutes Component={CostSheetEntLogs} />} />
          <Route path="/CostSheetEntForm/New" element={<ProtectedRoutes Component={CostSheetEntForm} />} />
          <Route path="/CostSheetEntForm/:series" element={<ProtectedRoutes Component={CostSheetEntForm} />} />
          <Route path='/CostSheetEntApprovals' element={<CostSheetEntAppv />} />
          <Route path='/CostSheetEntApprovals/:approvalRole/:encParam' element={<CostSheetEntAppv />} />

        </Routes>
      </Router>
    </>
  );
}

export default App;
